import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
	tag: 'ds-transclude',
})
export class Transclude {
	/**
	 * To "transclude" in this context means to move an element to a different part of the DOM dynamically
	 * This component allows you to pull another element inside it from a different part of the DOM
	 * For this to work, the component you are referencing must have been given a 'data-component-index' attribute
	 * This indexing attribute is used to pull in the correct element as there could be multiple of that kind
	 * See Body Tabs for an example of how this works and why it's needed
	 */

	// HTML/CSS selector string of component you wish to transclude (eg. a web component tag name such as 'ds-content-block')
	@Prop() component: string;

	// The index of the component, starting with 1. Eg. 3 would be the third instance found of the above component selector string
	@Prop() componentIndex: number = null;

	@Element() el: HTMLDsTranscludeElement;

	componentWillLoad() {
		if (this.component && this.componentIndex !== null) {
			const matchedComponent = document.querySelector(
				`[data-componentname="${this.component}"][data-component-index="${this.componentIndex}"]:not(.ds-cloned)`
			);
			if (matchedComponent) {
				(matchedComponent as HTMLInputElement).classList.add('ds-transcluded');
				this.el.appendChild(matchedComponent);
			}
		}
	}

	render() {
		return <Host></Host>;
	}
}
